// Types
export type { RecaptchaAction, RecaptchaEndpointConfig, HttpMethod } from './utils/types';
export { createAction } from './utils/types';

// Constants
export {
  BUILTIN_ACTIONS,
  RECAPTCHA_SITE_KEY_ENV,
  RECAPTCHA_TOKEN_HEADER,
  RECAPTCHA_ERROR_MESSAGES,
} from './utils/constants';

// Error utilities
export type { RecaptchaErrorCode } from './utils/errors';
export { isRecaptchaError, getRecaptchaErrorMessage } from './utils/errors';

// Adapter types and implementations
export type { IRecaptchaAdapter, RecaptchaAdapterType } from './adapters/types';
export { WebRecaptchaAdapter } from './adapters/webRecaptchaAdapter';
export { MobileRecaptchaAdapter } from './adapters/mobileRecaptchaAdapter';
export { MockRecaptchaAdapter } from './adapters/mockRecaptchaAdapter';

// Adapter Registry
export { recaptchaAdapterRegistry } from './recaptchaAdapterRegistry';
export type { RecaptchaAdapterRegistryDebugInfo } from './recaptchaAdapterRegistry';

// Endpoint Registry
export { recaptchaRegistry } from './recaptchaRegistry';

// Service (initialization)
export { initializeWebRecaptcha, preloadRecaptcha } from './recaptchaService';

// Interceptor
export { attachRecaptchaInterceptor } from './recaptchaInterceptor';

// Config
export { initializeDefaultEndpoints } from './recaptchaConfig';
